import Vue from 'vue';
import { encrypt, decrypt } from './crypto';

// 匹配url参数正则
const paramsReg = /([^?&=]+)=([^?&=]*)/g;

const encryptData = (str) => {
    return encodeURIComponent(encrypt(str));
};

// 加密url参数
const encryptStr = (urlStr) => {
    console.log(urlStr);
    let result = urlStr.slice(0, urlStr.indexOf('?') + 1);
    urlStr.replace(paramsReg, (rs, $1, $2) => {
        // 手动转译value（避免自动转出错）
        result += `${$1}=${encodeURIComponent(encrypt($2))}&`;
    });
    return result;
};

// 加密打开url方法
// ex: safeOpen(`#/share-team/team-content?shareId=${id}`, '_blank');
const safeOpen = (url, method) => {
    const encryptUrl = encryptStr(url);
    return method ? window.open(encryptUrl, method) : window.open(encryptUrl);
};

// 解密方法
// ex: safeGet(加密串);
const safeGet = (str) => {
    return (str && decrypt(str)) || '';
};

// 常用挂载到原型
Vue.prototype.$safeOpen = safeOpen;
Vue.prototype.$safeGet = safeGet;
Vue.prototype.$encryptData = encryptData;
